import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@emotion/react';

const Loading = (props) => {
    const theme = useTheme();
    return(
        <Box sx={{
            height: `calc(100vh - ${theme.spacing(6)})`,
            display: 'flex',
            flexDirection: 'row',
            padding: theme.spacing(3),
            gap: theme.spacing(3)
        }}>
            <Skeleton variant='rounded' sx={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: '15px',
                minWidth: '65px',
                height: '100%'
            }}/>
            <Skeleton variant='rounded' sx={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: '15px',
                width: '100%',
                height: '100%',
            }}/>
        </Box>
    );
};

export default Loading;